import React from "react";

export const makeHeader = (header, optional_text, withSort = false) => (
  <div className="header-th">
    <div className="header-th__content">{header}
      {withSort &&
        <span className="sort-icon"></span>
      }
    </div>
    { optional_text &&
    <span className="header-th__optional">{optional_text}</span>
    }
  </div>
);

/**
 * @param attributes
 * @param removedAttributes
 * @param data
 * @return {[string,string][]|*[]}
 * @Todo Remove code path for data (deprecated)
 */
export function buildHeaderArr (attributes, removedAttributes, data = []) {
  attributes = attributes || [];
  removedAttributes = removedAttributes || {};

  // Todo: Remove deprecated argument data
  if (!Array.isArray(attributes) || !Array.isArray(data)) {
    return [];
  }

  if (attributes.length !== 0) {
    return buildHeader(attributes, removedAttributes);
  } else if (data.length !== 0) {
    console.warn('DEPRECATION WARNING - meta.productFinderColumns is not set!');
    return buildHeaderDeprecated(data, removedAttributes);
  }

  return [];
}

/**
 * @desc Creates column data from incoming attributes, excluding the ones in removedAttributes
 * @param attributes
 * @param removedAttributes
 * @return {[string, string][]}
 * @Todo Refactor removedAttributes from {} to []
 */
function buildHeader(attributes, removedAttributes) {
  return attributes.reduce((accumulator, attribute) => {
    if (!removedAttributes.hasOwnProperty(attribute.attribute_key)) {
      accumulator.push([
        attribute.attribute_key,
        attribute.label
      ]);
    }
    return accumulator;
  }, []);
}


/**
 * @deprecated
 * @param data
 * @param removedAttributes
 * @return {[string, string][]}
 * @Todo Remove function once columns data is sufficiently up-to-date
 */
function buildHeaderDeprecated(data, removedAttributes) {
  let attributes = data.reduce((accumulator, data) => {
    return data.attributes.attributes.reduce((accumulator, attribute) => {
      if (removedAttributes && Object.prototype.hasOwnProperty.call(removedAttributes, attribute.attribute_key)) {
        return accumulator;
      }
      accumulator[attribute.attribute_key] = attribute.attribute_value.label;
      return accumulator;
    }, accumulator);
  }, {});
  return Object.entries(attributes);
}

export function buildDataArr (data, removedAttributes) {
  removedAttributes = removedAttributes || {};
  return data.map(data => {

    /* Fill the product states array according to the data coming from result_20.json */
    const productStates = [];

    if (data.attributes.field_product_state_list === 'new') {
      productStates.push({stateText: 'NEW', stateClass: 'new'});
    } else if (data.attributes.field_product_state_list === 'end_of_live') {
      productStates.push({stateText: 'EOL', stateClass: 'end-of-life'});
    }
    if (data.attributes.field_not_recommended_fnd !== null) {
      productStates.push({stateText: 'NRFND', stateClass: 'not-recommended-for-new-design'});
    }

    return {
      title: { link: ProductFinder.options.pathPrefix + data.attributes.path, value: data.attributes.title, model_id: data.attributes.model_id, data_sheet: data.attributes.available_datasheets, cad_data: data.attributes.cad_data, cad_data_link: ProductFinder.options.settings.cadDataPath, nostocksearch: data.attributes.field_nostocksearch, product_state: productStates},
      ...data.attributes.attributes.reduce((accumulator, attribute) => {
        if (removedAttributes && Object.prototype.hasOwnProperty.call(removedAttributes, attribute.attribute_key)) {
          return accumulator;
        }
        accumulator[attribute.attribute_key] = {
          rendered: attribute.attribute_value.rendered_value,
          type: attribute.attribute_value.type,
          unit: attribute.attribute_value.unit,
        };
        return accumulator;
      }, {})
    }
  });
}
